import { Component, OnInit } from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import clone from 'just-clone';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as fromDataServices from '../../data-services';
import { LoggingService } from '../../shared/services/logging';

@Component({
    selector: 'ef-toaster-container',
    templateUrl: './toaster-container.component.html',
    styleUrls: ['./toaster-container.component.scss'],
    standalone: false
})
export class ToasterContainerComponent implements OnInit {
    ToasterModelDS: EntityCollectionService<fromDataServices.Toaster.Toast>;
    ToasterModel$: Observable<fromDataServices.Toaster.Toast[]>;
    constructor(
        private log: LoggingService,
        public entityServices: EntityServices
    ) {
        this.log.verbose({ type: 'ToasterContainerComponent::' });
        this.ToasterModelDS =
            entityServices.getEntityCollectionService<fromDataServices.Toaster.Toast>(
                fromDataServices.Toaster.entityName
            );
    }
    ngOnInit(): void {
        this.ToasterModelDS.clearCache();
        // this.ToasterModelDS.getAll();
        this.ToasterModel$ = this.ToasterModelDS.entities$.pipe(
            map(items => [...clone(items)])
        );
    }
}
